import { useState } from 'react';
import type { ClinicFormData, ClinicCreatedData, UserFormData } from '../types/signup';

export type SignupStep = 1 | 2 | 3;

interface UseSignupFlowReturn {
  step: SignupStep;
  clinicData: ClinicFormData | null;
  clinicCreated: ClinicCreatedData | null;
  userData: UserFormData | null;
  loading: boolean;
  error: string | null;
  setStep: (step: SignupStep) => void;
  setClinicData: (data: ClinicFormData) => void;
  setClinicCreated: (data: ClinicCreatedData) => void;
  setUserData: (data: UserFormData) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  nextStep: () => void;
  prevStep: () => void;
  reset: () => void;
}

export const useSignupFlow = (): UseSignupFlowReturn => {
  const [step, setStep] = useState<SignupStep>(1);
  const [clinicData, setClinicData] = useState<ClinicFormData | null>(null);
  const [clinicCreated, setClinicCreated] = useState<ClinicCreatedData | null>(null);
  const [userData, setUserData] = useState<UserFormData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const nextStep = () => {
    if (step < 3) {
      setStep((prev) => (prev + 1) as SignupStep);
      setError(null);
    }
  };

  const prevStep = () => {
    if (step > 1) {
      setStep((prev) => (prev - 1) as SignupStep);
      setError(null);
    }
  };

  const reset = () => {
    setStep(1);
    setClinicData(null);
    setClinicCreated(null);
    setUserData(null);
    setLoading(false);
    setError(null);
  };

  return {
    step,
    clinicData,
    clinicCreated,
    userData,
    loading,
    error,
    setStep,
    setClinicData,
    setClinicCreated,
    setUserData,
    setLoading,
    setError,
    nextStep,
    prevStep,
    reset,
  };
};
